export type CartAddressInput = {
  first_name?: string | null;
  last_name?: string | null;
  phone?: string | null;
  company?: string | null;
  address_1?: string | null;
  address_2?: string | null;
  postal_code?: string | null;
  city?: string | null;
  province?: string | null;
  country_code?: string | null;
  metadata?: Record<string, unknown> | null;
};

type ResolveCartAddressesInput = {
  shippingAddress?: CartAddressInput | null;
  billingAddress?: CartAddressInput | null;
  fallbackAddress?: CartAddressInput | null;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  defaultCountryCode: string;
};

const toCartAddress = (
  address: CartAddressInput | null | undefined,
  identity: Pick<ResolveCartAddressesInput, "firstName" | "lastName" | "phone" | "defaultCountryCode">
) => ({
  first_name: address?.first_name || identity.firstName || "Guest",
  last_name: address?.last_name || identity.lastName || "User",
  phone: address?.phone || identity.phone || "",
  company: address?.company || "",
  address_1: address?.address_1 || "",
  address_2: address?.address_2 || "",
  postal_code: address?.postal_code || "",
  city: address?.city || "",
  province: address?.province || "",
  country_code: address?.country_code || identity.defaultCountryCode,
  metadata: address?.metadata || undefined,
});

const withoutTechnicalPlaceholder = (address?: CartAddressInput | null) =>
  address?.address_1?.trim().toLowerCase() === "default address" ? undefined : address;

export const resolveCartAddresses = ({
  shippingAddress,
  billingAddress,
  fallbackAddress,
  firstName,
  lastName,
  phone,
  defaultCountryCode,
}: ResolveCartAddressesInput) => {
  const safeShippingAddress = withoutTechnicalPlaceholder(shippingAddress);
  const safeBillingAddress = withoutTechnicalPlaceholder(billingAddress);
  const safeFallbackAddress = withoutTechnicalPlaceholder(fallbackAddress);
  const resolvedShippingAddress = safeShippingAddress || safeBillingAddress || safeFallbackAddress;
  const resolvedBillingAddress = safeBillingAddress || resolvedShippingAddress;
  const identity = { firstName, lastName, phone, defaultCountryCode };

  return {
    shippingAddress: toCartAddress(resolvedShippingAddress, identity),
    billingAddress: toCartAddress(resolvedBillingAddress, identity),
  };
};
